<template>
  <div id="projectItemComp">
    <div class="left">
      <van-image class="img" fit="cover" :src="item.defaultImage" />
      <div v-if="status[item.permissions]" class="badge" :class="[status[item.permissions].bg]">
        <div class="txt">
          {{ status[item.permissions].name }}
        </div>
      </div>
    </div>
    <div class="right">
      <div class="top">
        <div class="title text-ellipsis">{{item.projectName || item.name}}</div>
        <div class="tags">
          <div class="tag" v-for="(v,i) in `${item.subjectName}${item.tag?',':''}${item.tag}`.split(',')" :key="i">{{v}}</div>
        </div>
      </div>
      <div class="bottom">
        <div class="info">
          <van-image class="icon" fit="cover" :src="require('@/assets/images/research/icon_user_01.png')" />
          <div class="item text-ellipsis" v-if="item.member">{{ item.member && item.member.length && item.member.join(',') }}</div>
          <template v-else>
            <div class="item text-ellipsis">{{ item.head }}</div>
            <div class="line">|</div>
            <div class="item text-ellipsis">{{ item.studioName }}</div>
          </template>
        </div>
        <div class="icons">
          <div class="item">
            <van-image class="icon" fit="cover" :src="require('@/assets/images/research/icon_hand_01.png')" />
            <span>{{item.likeNum}}</span>
          </div>
          <div class="item">
            <van-image class="icon" fit="cover" :src="require('@/assets/images/research/icon_eye_01.png')" />
            <span>{{item.visitNum}}</span>
          </div>
          <div class="item">
            <van-image class="icon" fit="cover" :src="require('@/assets/images/research/icon_down_01.png')" />
            <span>{{item.downloadNum}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectItemComp',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    badgeClass: {
      type: [Object, Array], // 可选值bg-1黄， bg-2红，bg-3绿，bg-4灰
      default: () => {}
    }
  },
  data () {
    return {
      status: {
        1: {
          name: '不公开',
          bg: 'bg-4'
        },
        2: {
          name: '内部公开',
          bg: 'bg-1'
        },
        3: {
          name: '外部公开',
          bg: 'bg-1'
        },
        4: {
          name: '暂停',
          bg: 'bg-4'
        }
      }
    };
  }
};
</script>

<style scoped lang="less">
#projectItemComp {
  width: 694px;
  margin: 0 auto 20px;
  background-color: #fff;
  padding: 35px 20px;
  border-radius: 16px;
  display: flex;
  .left {
    position: relative;
    flex-shrink: 0;
    width: 258px;
    height: 170px;
    .img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;
    }
    .badge {
      position: absolute;
      top: -10px;
      left: 0;
      z-index: 2;
      .txt{
        min-width: 110px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 24px;
        color: #FFFFFF;
        padding-left: 16px;
        padding-right: 16px;
        border-radius: 12px 0 12px 0;
        position: relative;
        z-index: 1;
      }
      &:after{
        content: '';
        width: 0;
        height: 0;
        border: 6px solid transparent;
        border-top-width: 0;
        border-bottom-width: 10px;
        overflow: hidden;
        position: absolute;
        left: 100%;
        top: 0;
        transform: translateX(-6px);
        z-index: -1;
      }
      &.bg-1{
        .txt {
          background-image: linear-gradient(270deg, #76DF8A 0%, #42D9A1 43%, #35D092 100%);
          background-color: #76DF8A;
        }
        &:after{
          border-left-color: #66C277;
          border-bottom-color: #66C277;
        }
      }
      &.bg-2{
        .txt {
          background-image: linear-gradient(270deg, #C7C8D1 0%, #999AAA 100%);
          background-color: #C7C8D1;
        }
        &:after{
          border-left-color: #999AAA;
          border-bottom-color: #999AAA;
        }
      }
    }

  }
  .right {
    padding-left: 20px;
    flex: 1;
    width: 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top {
      .title {
        width: 376px;
        font-size: 26px;
        color: #333444;
      }
      .tags {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-right: -8px;
        margin-left: -8px;
        padding-top: 4px;
        padding-bottom: 4px;
        .tag {
          margin: 4px 8px;
          padding: 0 8px;
          border: 2px solid #999AAA;
          border-radius: 40px;
          font-size: 20px;
          color: #999AAA;
          display: flex;
          align-items: center;
          justify-content: center;
          &:first-child {
            background: #FC485D;
            border: 2px solid #FC485D;
            color: #fff;
          }
        }
      }
    }
    .bottom {
      .info {
        width: 100%;
        font-size: 22px;
        color: #999AAA;
        display: flex;
        align-items: center;
        .icon {
          width: 28px;
          height: 24px;
          flex-shrink: 0;
        }
        .line {
          flex-shrink: 0;
          margin: 0 4px;
        }
      }
      .icons {
        margin-top: 14px;
        display: flex;
        align-items: center;
        .item {
          margin-right: 10px;
          display: flex;
          align-items: center;
          .icon {
            width: 24px;
            height: 24px;
          }
          span {
            margin-left: 4px;
            font-size: 20px;
            font-weight: 400;
            color: #999AAA;
          }
        }
      }
    }
  }
}
</style>